export default __webpack_public_path__ + "static/media/D0.460d86db.mp3";